import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FeeCode } from 'src/app/enums/fee.code';
import { Fees } from 'src/app/model/fees';
import { CommonUtil } from 'src/app/services/common.util';

@Component({
    selector: 'app-personal-user-fees',
    templateUrl: './personal-user-fees.component.html',
    styleUrls: ['./personal-user-fees.component.css'],
})
export class PersonalUserFeesComponent {
    @Input() personalFeeList: Array<Fees>;
    @Input() editPersonal = false;
    @Input() showEditPencil = true;
    @Input() parentToUpdate = false;
    @Input() title = 'Personal User';
    @Output() updateFee = new EventEmitter();

    feeCode = FeeCode;
    feeLabel = this.commonUtil.getFeeLabels();

    constructor(public commonUtil: CommonUtil) { }

    changeView() {
        this.editPersonal = !this.editPersonal;
    }

    submit() {
        this.updateFee.emit('personal');
        this.changeView();
    }

}
